/* eslint-disable import/no-cycle */
import React, {
  Fragment, useContext, useEffect, useState,
} from 'react'
import PropTypes from 'prop-types'
import {
  AppBar,
  Avatar,
  Box,
  Chip,
  IconButton,
  Toolbar,
  Typography,
} from '@material-ui/core'
import useWidth from '@hooks/useWidth'
import clsx from 'clsx'
import MenuIcon from '@material-ui/icons/Menu'
import { useHistory } from 'react-router-dom'
import icons from '@assets/icons'
import application from '@config/application'
import Cookies from 'js-cookie'
import CopyToClipboard from '@components/CopyClipBoard'
import useElementHover from '@hooks/useElementHover'
import { resellerApiWithToken } from '@api/baseApi'
import { AdminContext } from '@containers/Layout/AdminProvider'
import useAxios from '@hooks/useAxios'
import StoreIcon from '@material-ui/icons/Store'
import useStyles from './header-jss'
import ChipMenu from './ChipMenu'
import NotificationMenu from './NotificationMenu'

const Header = ({ open, toggleDrawer, pageTitle }) => {
  const classes = useStyles()
  const history = useHistory()
  const scope = Cookies.get('scope')
  const affiliateCode = JSON.parse(localStorage.getItem('payload'))?.affiliate_code || ''
  // eslint-disable-next-line no-unused-vars
  const name = JSON.parse(localStorage.getItem('payload'))?.name || 'User'
  const [creditLimit, setCreditLimit] = useState('')
  const [lastPoint, setLastPoint] = useState(0)
  const [deposit, setDeposit] = useState('')
  const [stores, setStores] = useState([])
  const { reload } = useContext(AdminContext)
  const listStore = useAxios(resellerApiWithToken, 'get', '/resellers/stores_users?per_page=50')
  const width = useWidth()
  const refferal = JSON.parse(localStorage.getItem('payload'))?.no_member

  useEffect(() => {
    listStore.fetch()
  }, [])

  useEffect(() => {
    if (Array.isArray(listStore.data)) {
      const menu = []
      listStore.data.map((item) => menu.push({
        id: item.id,
        name: item.store_name,
        onClick: () => window.open(`${item.url}?ref=${refferal}`),
        icon: <StoreIcon />,
      }))
      setStores(menu)
    }
  }, [listStore.data, refferal])

  const getDeposit = async () => {
    try {
      const { status, data: { data } } = await resellerApiWithToken.get('/resellers/deposits')

      if (status === 200) {
        setCreditLimit(data?.credit_limit)
        setDeposit(data?.deposit)
        setLastPoint(data?.last_point)
      }
    } catch (error) {
      setCreditLimit('')
      setDeposit('')
      setLastPoint(0)
    }
  }

  useEffect(() => {
    getDeposit()
  }, [reload])

  const getInitialName = () => {
    const arrName = name.split(' ')
    let initialName = ''

    arrName.map((str) => initialName += str.charAt(0))

    return initialName.toUpperCase()
  }

  const handleLogout = async () => {
    await localStorage.clear()
    await Cookies.remove('scope')
    await Cookies.remove('reseller_app_token')
    if (scope === 'affiliate') {
      history.push(`${application.prefix}/affiliate`)
    } else {
      history.push(`${application.prefix}/login`)
    }
  }

  const handleMenuUser = () => {
    history.push(`${application.prefix + application.path}/account`)
  }

  const handleChangePassword = () => {
    history.push(`${application.prefix + application.path}/change-password`)
  }

  const creditChip = useElementHover()
  const depositChip = useElementHover()
  const lastPointChip = useElementHover()

  const menuUser = [
    {
      id: 0,
      name: 'Akun Saya',
      onClick: handleMenuUser,
      icon: <img src={icons.UserIcon} alt="user" height={18} width={18} />,
    },
    {
      id: 1,
      name: 'Ubah Kata Sandi',
      onClick: handleChangePassword,
      icon: <img src={icons.KeyIcon} alt="user" height={18} width={18} />,
    },
    {
      id: 3,
      name: 'Keluar',
      onClick: handleLogout,
      icon: <img src={icons.LogoutIcon} alt="user" height={18} width={18} />,
    },
  ]

  const affiliateMenu = [
    {
      id: 3,
      name: 'Keluar',
      onClick: handleLogout,
      icon: <img src={icons.LogoutIcon} alt="user" height={18} width={18} />,
    },
  ]

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, classes.appBarRoot, {
        [classes.appBarShift]: open,
      })}
    >
      <Toolbar
        className={classes.toolbar}
        disableGutters={['xs'].includes(width)}
      >
        <IconButton
          className={clsx({ [classes.hide]: open })}
          olor="primary"
          onClick={toggleDrawer}
        >
          <MenuIcon className={classes.menuIcon} />
        </IconButton>
        <Typography
          variant="h1"
          color="primary"
          className={classes.menuTitle}
        >
          {pageTitle}
        </Typography>
        <div className={classes.toolbarAction}>
          {
            scope === 'reseller'
            && (
            <Fragment>
              <Chip
                variant="outlined"
                color="primary"
                label={depositChip.isHovered ? 'Saldo Deposit' : deposit}
                {...depositChip.triggerHover}
                style={{
                  width: ['xs'].includes(width) && 100,
                  minWidth: !['xs'].includes(width) && 120,
                  backgroundColor: '#ECF2F5',
                }}
              />
              <Box width={10} />
              <Chip
                variant="outlined"
                color="primary"
                label={creditChip.isHovered ? 'Limit Kredit' : creditLimit}
                {...creditChip.triggerHover}
                style={{
                  width: ['xs'].includes(width) && 100,
                  minWidth: !['xs'].includes(width) && 120,
                  backgroundColor: '#ECF2F5',
                  display: ['xs'].includes(width) && 'none',
                }}
              />
              <Box width={10} />
              <Chip
                variant="outlined"
                color="primary"
                label={lastPointChip.isHovered ? 'Poin Saya' : `${lastPoint || 0} poin`}
                {...lastPointChip.triggerHover}
                style={{
                  width: ['xs'].includes(width) && 100,
                  minWidth: !['xs'].includes(width) && 120,
                  backgroundColor: '#ECF2F5',
                }}
              />
              <NotificationMenu />
              <ChipMenu
                label={window.location.hostname}
                avatar={<StoreIcon />}
                menuItem={stores}
              />
              <ChipMenu
                label={name}
                avatar={<Avatar>{getInitialName()}</Avatar>}
                menuItem={menuUser}
              />
            </Fragment>
            )
          }

          {
            scope === 'affiliate' && (
              <Fragment>

                <NotificationMenu />
                <CopyToClipboard
                  text={affiliateCode}
                  link={affiliateCode}
                  variant="outlined"
                  style={{ borderRadius: 20 }}
                />
                <ChipMenu
                  label={name}
                  avatar={<Avatar>{getInitialName()}</Avatar>}
                  menuItem={affiliateMenu}
                />
              </Fragment>
            )
          }

        </div>
      </Toolbar>
    </AppBar>
  )
}

Header.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  pageTitle: PropTypes.string.isRequired,
}

export default Header
